import { NavArrowLeft } from 'iconoir-react'
import { ReactElement } from 'react'

export function MobileOverlay({
  open,
  closeLabel,
  children,
  onClose,
}: {
  open: boolean
  closeLabel: string
  children: ReactElement
  onClose: () => void
}): ReactElement {
  return open ? (
    <div className="fixed inset-0 bottom-16 grid h-full animate-fade-up items-end overflow-hidden bg-white animate-ease-in md:hidden">
      <div className="flex h-full w-full flex-col gap-y-1 overflow-hidden px-0 pb-2 shadow-lg">
        <button
          onClick={onClose}
          className="flex w-full items-center gap-x-2 border-b border-t-0 border-trn-200 bg-white pb-2 text-gray-500"
        >
          <NavArrowLeft strokeWidth={3} height={20} width={24} className="text-trn-700" />
          <div className="text-heading-md text-neutral-900">{closeLabel}</div>
        </button>
        {children}
      </div>
    </div>
  ) : (
    <></>
  )
}
